import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import ProductCard from "@/components/site/ProductCard";
import Seo from "@/components/site/Seo";

export function NewArrivalsPage() {
  const [products, setProducts] = useState([]);
  useEffect(() => { api.get("/products", { params: { new_arrival: true, limit: 60 } }).then(r => setProducts(r.data)); }, []);
  return <><Seo page="new-arrivals"/><ListingShell title="New Arrivals" subtitle="Latest IT products just added to our catalogue." items={products}/></>;
}
export function DealsPage() {
  const [products, setProducts] = useState([]);
  const [offers, setOffers] = useState([]);
  useEffect(() => {
    api.get("/products", { params: { offer: true, limit: 60 } }).then(r => setProducts(r.data));
    api.get("/offers").then(r => setOffers(r.data));
  }, []);
  return (
    <div className="bg-[#F8FAFC] min-h-screen">
      <Seo page="deals"/>
      <div className="bg-[#0F172A] text-white py-10"><div className="container-x">
        <h1 className="font-heading font-extrabold text-3xl sm:text-4xl">Deals & Offers</h1>
        <p className="text-slate-300 mt-1">Current offers on selected IT products.</p>
      </div></div>
      <div className="container-x py-10">
        {offers.length > 0 && <div className="grid md:grid-cols-3 gap-4 mb-8">
          {offers.map(o => (
            <div key={o.id} className="bg-white border border-[#E2E8F0] rounded-md p-6">
              <div className="text-xs uppercase tracking-widest text-[#EA580C] font-semibold">{o.discount}</div>
              <div className="font-heading font-bold text-lg mt-1">{o.title}</div>
              <p className="text-slate-600 text-sm mt-1">{o.description}</p>
            </div>
          ))}
        </div>}
        {products.length === 0 ? (
          <div className="bg-white border border-[#E2E8F0] rounded-md p-12 text-center">
            <div className="font-heading font-bold text-lg">No active offers right now</div>
            <p className="text-slate-500 mt-1">Check back soon or contact us for current wholesale availability.</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            {products.map(p => <ProductCard key={p.id} product={p}/>)}
          </div>
        )}
      </div>
    </div>
  );
}
function ListingShell({ title, subtitle, items }) {
  return (
    <div className="bg-[#F8FAFC] min-h-screen">
      <div className="bg-[#0F172A] text-white py-10"><div className="container-x">
        <h1 className="font-heading font-extrabold text-3xl sm:text-4xl">{title}</h1>
        <p className="text-slate-300 mt-1">{subtitle}</p>
      </div></div>
      <div className="container-x py-10">
        {items.length === 0 ? (
          <div className="bg-white border border-[#E2E8F0] rounded-md p-12 text-center"><div className="font-heading font-bold text-lg">Nothing here yet</div></div>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">{items.map(p => <ProductCard key={p.id} product={p}/>)}</div>
        )}
      </div>
    </div>
  );
}
